function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 11h4v10H3V7h4V4l5-2 5 2zM5 9v2h2V9zm4 0v2h2V9zm0-4v2h2V5zm4 8v2h2v-2zm0-8v2h2V5zm4 8v2h2v-2zM5 13v2h2v-2zm4 0v2h2v-2zm4 4v2h2v-2zm0-8v2h2V9zm4 8v2h2v-2zM5 17v2h2v-2zm4 0v2h2v-2z",
  fillRule: "evenodd",
  fill: "currentColor"
});

function SvgLocationCity(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCity);
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im0xNyAxMWg0djEwaC02LTYtNnYtMTRoNHYtM2w1LTIgNSAyem0tMTItMnYyaDJ2LTJ6bTQgMHYyaDJ2LTJ6bTAtNHYyaDJ2LTJ6bTQgOHYyaDJ2LTJ6bTAtOHYyaDJ2LTJ6bTQgOHYyaDJ2LTJ6bS0xMiAwdjJoMnYtMnptNCAwdjJoMnYtMnptNCA0djJoMnYtMnptMC04djJoMnYtMnptNCA4djJoMnYtMnptLTEyIDB2Mmgydi0yem00IDB2Mmgydi0yeiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9nPjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };